const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
export const TOKEN_KEY = 'tpg_admin_token';

const formatDetail = (detail) => {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || JSON.stringify(item)).join(' ');
  return 'Something went wrong. Please try again.';
};

const request = async (path, options = {}) => {
  const response = await fetch(`${API}/${path}`, options);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(formatDetail(data.detail));
    error.status = response.status;
    throw error;
  }
  return data;
};

export const adminLogin = (email, password) => request('login', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ email, password }),
});

export const adminGet = (path, token) => request(path, { headers: { Authorization: `Bearer ${token}` } });
